export const FLAG_GETTING_ITINERARY_COUNTER_REPORTS =
  'FLAG_GETTING_ITINERARY_COUNTER_REPORTS';
export const GET_ITINERARY_COUNTER_REPORTS = 'GET_ITINERARY_COUNTER_REPORTS';
export const FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY =
  'FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY';
export const GET_ITINERARY_COUNTER_REPORT = 'GET_ITINERARY_COUNTER_REPORT';
export const CLEAR_ITINERARY_COUNTER_REPORT = 'CLEAR_ITINERARY_COUNTER_REPORT';
